import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
export class SliderManager {
    constructor(container) {
        this.container = container;
        this.swiper = null;
    }
    setup() {
        this.swiperWrapper = this.container.querySelector('.swiper-wrapper');
        this.sliderPrevBtn = this.container.querySelector('.slider__btn_prev');
        this.sliderNextBtn = this.container.querySelector('.slider__btn_next');
        this.initSwiper();
    }
    initSwiper() {
        console.log('Инициализация Swiper...');
        this.swiper = new Swiper('.swiper', {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 80,
            navigation: {
                nextEl: this.sliderNextBtn,
                prevEl: this.sliderPrevBtn,
                disabledClass: 'swiper-button-disabled'
            },
            breakpoints: {
                320: { slidesPerView: 1.2, spaceBetween: 25 },
                768: { slidesPerView: 2, spaceBetween: 40 },
                1024: { slidesPerView: 3, spaceBetween: 80 }
            }
        });
    }
    updateSlides(events) {
        this.swiperWrapper.innerHTML = '';
        events.forEach(event => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            const year = document.createElement('p');
            year.className = 'slider__year';
            year.textContent = event.year.toString();
            const description = document.createElement('p');
            description.className = 'slider__description';
            description.textContent = event.description;
            slide.appendChild(year);
            slide.appendChild(description);
            this.swiperWrapper.appendChild(slide);
        });
        if (this.swiper) {
            this.swiper.update();
            this.swiper.slideTo(0, 0);
        }
    }
    destroy() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }
}
